/* ─── ANNOUNCEMENT BAR ─────────────────────────────────────────────────── */
// const messages = [
//   "Free shipping on orders over US$135 · Canada $119+",
//   "Supporting SickKids Foundation — $1 donated per item sold",
//   "Culturally-rooted luxury, hand-crafted in Canada",
// ];
// let annIdx = 0;
// const annBar = document.getElementById('announcement-bar');
// setInterval(() => {
//   annBar.style.opacity = '0';
//   setTimeout(() => {
//     annIdx = (annIdx + 1) % messages.length;
//     annBar.textContent = messages[annIdx];
//     annBar.style.opacity = '1';
//   }, 350);
// }, 4000);

/* ─── NAV SCROLL ────────────────────────────────────────────────────────── */
const mainNav = document.getElementById('main-nav');
window.addEventListener('scroll', () => {
  mainNav.classList.toggle('scrolled', window.scrollY > 60);
});

/* ─── MOBILE MENU ───────────────────────────────────────────────────────── */
function toggleMobileMenu() {
  document.getElementById('mobile-menu').classList.toggle('open');
}

/* ─── GIVING BACK COUNTER ───────────────────────────────────────────────── */
let count = 1247;
const countEl = document.getElementById('giving-count');
setInterval(() => {
  count += Math.floor(Math.random() * 3);
  countEl.textContent = '$' + count.toLocaleString();
}, 8000);

/* ─── NEWSLETTER ────────────────────────────────────────────────────────── */
function handleNewsletterSubmit() {
  const email = document.getElementById('newsletter-email').value;
  if (!email) return;
  document.getElementById('newsletter-form').style.display = 'none';
  document.getElementById('newsletter-success').style.display = 'block';
}
document.getElementById('newsletter-email').addEventListener('keydown', e => {
  if (e.key === 'Enter') handleNewsletterSubmit();
});

/* ─── TWEAKS PANEL ──────────────────────────────────────────────────────── */
function setBg(mode) {
  const r = document.documentElement;
  document.querySelectorAll('#bg-options .tweak-btn').forEach(b => b.classList.toggle('active', b.dataset.bg === mode));
  if (mode === 'warm') { r.style.setProperty('--warm-white','oklch(98.5% 0.006 82)'); r.style.setProperty('--cream','oklch(96% 0.012 82)'); r.style.setProperty('--charcoal','oklch(16% 0.01 60)'); document.body.style.background = 'var(--warm-white)'; }
  if (mode === 'cool') { r.style.setProperty('--warm-white','oklch(99% 0.003 220)'); r.style.setProperty('--cream','oklch(96% 0.006 220)'); r.style.setProperty('--charcoal','oklch(16% 0.01 60)'); document.body.style.background = 'var(--warm-white)'; }
  if (mode === 'dark') { r.style.setProperty('--warm-white','oklch(12% 0.01 60)'); r.style.setProperty('--cream','oklch(16% 0.01 60)'); r.style.setProperty('--charcoal','oklch(94% 0.006 82)'); document.body.style.background = 'var(--warm-white)'; }
  window.parent.postMessage({type:'__edit_mode_set_keys', edits:{bgMode:mode}},'*');
}
function setAccent(name, val, el) {
  document.documentElement.style.setProperty('--gold', val);
  document.querySelectorAll('.tweak-swatch').forEach(s => s.classList.remove('active'));
  el.classList.add('active');
  window.parent.postMessage({type:'__edit_mode_set_keys', edits:{accent:name}},'*');
}
function setNav(style, btn) {
  document.querySelectorAll('#nav-options .tweak-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  window.parent.postMessage({type:'__edit_mode_set_keys', edits:{navStyle:style}},'*');
}
window.addEventListener('message', e => {
  if (e.data?.type === '__activate_edit_mode') document.getElementById('tweaks-panel').classList.add('open');
  if (e.data?.type === '__deactivate_edit_mode') document.getElementById('tweaks-panel').classList.remove('open');
});
window.parent.postMessage({type:'__edit_mode_available'},'*');

  // Scroll reveal
  const reveals = document.querySelectorAll('.reveal');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((e, i) => {
      if (e.isIntersecting) {
        setTimeout(() => e.target.classList.add('visible'), i * 80);
        observer.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });
  reveals.forEach(el => observer.observe(el));

  // FAQ toggle
  document.querySelectorAll('.faq-q').forEach(q => {
    q.addEventListener('click', () => {
      const item = q.parentElement;
      const wasOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
      if (!wasOpen) item.classList.add('open');
    });
  });


  